import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.detail || data.error || data.message || fallback;
};
const isFormData = (value) => {
    return typeof FormData !== "undefined" && value instanceof FormData;
};
export async function getPublicTravelPlans(params) {
    const { baseUrl, statusId = 4, token } = params;
    const query = statusId !== undefined && statusId !== null ? `?status=${statusId}` : "";
    const data = await apiFetch(`/travel/api/get_public_travel_plan/${query}`, {
        baseUrl,
        token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить публичные путешествия"));
    }
    return data;
}
export async function getPublicTravelPlanDetail(params) {
    const { baseUrl, travelPlanId, travelPlanSlug, detailUrl, token } = params;
    const identifier = travelPlanSlug !== null && travelPlanSlug !== void 0 ? travelPlanSlug : travelPlanId;
    let path = "";
    if (typeof detailUrl === "string" && detailUrl.trim() !== "") {
        const normalizedDetailUrl = detailUrl.trim();
        if (/^https?:\/\//i.test(normalizedDetailUrl)) {
            try {
                const parsedUrl = new URL(normalizedDetailUrl);
                path = `${parsedUrl.pathname}${parsedUrl.search}`;
            }
            catch {
                path = normalizedDetailUrl;
            }
        }
        else {
            path = normalizedDetailUrl;
        }
    }
    else if (identifier !== undefined && identifier !== null && String(identifier).trim() !== "") {
        path = `/travel/api/get_public_travel_plan_detail/${identifier}/`;
    }
    else {
        throw new Error("Не указан идентификатор публичного путешествия");
    }
    const data = await apiFetch(path, {
        baseUrl,
        token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить детали публичного путешествия"));
    }
    return data;
}
export async function createPublicTravelPlan(params) {
    const { baseUrl, token, csrfToken, formData } = params;
    const data = await apiFetch(`/travel/api/public_travel_plan_created/`, {
        baseUrl,
        token,
        method: "POST",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось создать публичное путешествие"));
    }
    return data;
}
export async function getAdminPublicTravelCopySources(params) {
    const data = await apiFetch('/travel/api/admin/public-travel-plans/copy-sources/', { ...params, method: 'GET' });
    if (data.success === false)
        throw new Error(getErrorMessage(data, 'Не удалось загрузить исходные путешествия'));
    return data;
}
export async function copyAdminPublicTravelPlan(params) {
    const data = await apiFetch('/travel/api/admin/public-travel-plans/copy/', {
        baseUrl: params.baseUrl, token: params.token, method: 'POST', body: params.formData,
        headers: params.csrfToken ? { 'X-CSRFToken': params.csrfToken } : undefined,
        requestTimeoutMs: 180000,
    });
    if (data.success === false)
        throw new Error(getErrorMessage(data, 'Не удалось скопировать публичное путешествие'));
    return data;
}
export async function updatePublicTravelPlan(params) {
    const { baseUrl, travelPlanId, token, csrfToken, body } = params;
    const useFormData = isFormData(body);
    const data = await apiFetch(`/travel/api/public_travel_plan_update/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: {
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
            ...(useFormData ? {} : { "Content-Type": "application/json" })
        },
        body: useFormData ? body : JSON.stringify(body)
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось обновить публичное путешествие"));
    }
    return data;
}
export async function deletePublicTravelPlan(params) {
    const { baseUrl, travelPlanId, token, csrfToken } = params;
    const data = await apiFetch(`/travel/api/public_delete_travel_plan/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось удалить публичное путешествие"));
    }
    return data;
}
export async function setPublicTravelPlanLike(params) {
    const { baseUrl, travelPlanId, isLiked, token, csrfToken } = params;
    const data = await apiFetch(`/travel/api/public_travel_plan_like/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify({ is_liked: isLiked }),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось изменить лайк путешествия"));
    }
    return data;
}
export async function generateTravelDescriptionGpt(params) {
    var _a, _b;
    const { baseUrl, travelPlanId, token, csrfToken, prompt } = params;
    const additionalContext = String((_a = prompt === null || prompt === void 0 ? void 0 : prompt.additionalContext) !== null && _a !== void 0 ? _a : "").trim();
    const generationNotes = String((_b = prompt === null || prompt === void 0 ? void 0 : prompt.generationNotes) !== null && _b !== void 0 ? _b : "").trim();
    const hasPrompt = Boolean(additionalContext || generationNotes);
    const data = await apiFetch(`/external_services/api/gpt/travel-description/${travelPlanId}/?async=1`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
            ...(hasPrompt ? { "Content-Type": "application/json" } : {}),
        },
        ...(hasPrompt
            ? {
                body: JSON.stringify({
                    additional_context: additionalContext,
                    generation_notes: generationNotes,
                }),
            }
            : {}),
        waitForBackgroundTask: false,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось сгенерировать описание путешествия"));
    }
    return data;
}
export async function generateItineraryItemsGpt(params) {
    const { baseUrl, travelPlanId, token, csrfToken, form } = params;
    const data = await apiFetch(`/external_services/api/gpt/itinerary-items/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify(form),
        waitForBackgroundTask: false,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось сгенерировать пункты маршрута"));
    }
    return data;
}
export async function generatePublicItineraryPreview(params) {
    const { baseUrl, departureCity, destination, dateStart, dateFinish, interests = "", signal } = params;
    return apiFetch("/external_services/api/gpt/public-itinerary-preview/", {
        baseUrl,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            departure_city: departureCity,
            destination,
            interests,
            date_start: dateStart,
            date_finish: dateFinish,
        }),
        signal,
        redirectOnUnauthorized: false,
    });
}
export async function claimPublicItineraryPreview(params) {
    const { baseUrl, travelPlanId, previewToken, token, csrfToken } = params;
    return apiFetch(`/external_services/api/gpt/public-itinerary-preview/claim/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify({ preview_token: previewToken }),
    });
}
